import React from 'react';
import { IAdminDashboardComponent, adminShareDashboardComponents } from '../../api/admin';
import ShareResourceDialog, { ShareableItem } from './ShareResourceDialog';

interface Props {
	open: boolean;
	onClose: () => void;
	components: IAdminDashboardComponent[];
	sourceUserId: number;
}

function componentLabel(c: IAdminDashboardComponent): string {
	const parts: string[] = [c.type];
	if (c.info) parts.push(c.info);
	parts.push(`order: ${c.order ?? '?'}`);
	if (c.size != null) parts.push(`size: ${c.size}`);
	return parts.join(' · ');
}

export default function ShareDashboardDialog({ open, onClose, components, sourceUserId }: Props) {
	const items: ShareableItem[] = components.map((c) => ({
		id: c.id,
		name: componentLabel(c),
	}));

	async function handleShare(itemIds: number[], targetUserIds: number[], _newNames: Record<number, string>) {
		await Promise.all(
			targetUserIds.map((uid) => adminShareDashboardComponents(sourceUserId, itemIds, uid))
		);
	}

	return (
		<ShareResourceDialog
			open={open}
			onClose={onClose}
			items={items}
			resourceLabel="dashboard component"
			sourceUserId={sourceUserId}
			onShare={handleShare}
		/>
	);
}
